var map = {
	"./customer-01.jpg": 70577,
	"./customer-02.jpg": 12806,
	"./customer-03.jpg": 93859,
	"./customer-04.jpg": 62704,
	"./customer-05.jpg": 6157,
	"./customer-06.jpg": 57666,
	"./customer-07.jpg": 94015,
	"./customer-08.jpg": 49916,
	"./customer-09.jpg": 63641,
	"./customer-10.jpg": 83795,
	"./customer-11.jpg": 28534,
	"./customer-12.jpg": 78145,
	"./customer-13.jpg": 100,
	"./customer-14.jpg": 26479,
	"./customer-15.jpg": 50098,
	"./customer-16.jpg": 69053,
	"./customer-17.jpg": 59840,
	"./customer-18.jpg": 42619,
	"./customer-19.jpg": 41310,
	"./customer-20.jpg": 6862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68045;